export function ipfsGatewayImage(cid: string) {
  const url = `https://coffee-advisory-hamster-920.mypinata.cloud/ipfs/${cid}`;
  return url;
}
